
import Enumerable from "linq";
import { Component, Mixins, Prop, Emit, Watch } from "vue-property-decorator";
import { DomainRegistry } from "../../../domain";
import { default as WorkflowCommonMixin } from "./WorkflowCommonMixin.vue";
import { ReceptionDispInfo } from "../../../domain/workflow";
import { ReceptionReference, ReceptionCommentDispInfo, ReceptionPermissions, ReceptionDetailPermissions } from "../../../domain/workflow/reference";
import { ReceptionDetail, ReceptionCommentSet } from "../../../domain/workflow/reception";
import { ReceptionListDispInfo, ReceptionSummary } from "../../../domain/workflow/list";
import { ReceptionSearchCondition } from "../../../domain/workflow/search";
import { ButtonInfo, DocumentCreateButtonInfo } from "../../../domain/workflow/items";
import { ReceptionCreateKinds, ReceptionReferenceKinds } from "../../../domain/workflow/kinds";
import { Patient } from "../../../domain/patient";
import { Department } from "../../../domain/department";

import { UnmanagedDocumentSummaryInformation } from "../../../domain/document";
import { DepartmentGroupSelectableMixin } from "../../department/mixins";
import WorkflowActionConfirmDialog from "../dialogs/WorkflowActionConfirmDialog.vue";

@Component({
})
export default class RequestListViewMixin extends Mixins(WorkflowCommonMixin, DepartmentGroupSelectableMixin) {

  @Prop()
  defaultDepartmentsCondition: Department[];

  @Prop()
  isAdmin: boolean;

  @Prop()
  paramPatientNo: string;

  @Prop()
  paramIsPatientFixed: boolean;

  @Prop()
  paramReceptionId: number;

  @Prop()
  paramReceptionDetailId: number;

  @Prop()
  workflowActionConfirmDialog: WorkflowActionConfirmDialog;

  data(): any {
    return {
      displaySetting: null as ReceptionListDispInfo,
      overLimitMessage: null,
      receptionList: [],
      selectedReception: null as ReceptionSummary,
      reference: null as ReceptionReference,

      isShowPreview: true,
      isLoading: false,
      isRegistering: false,
      preReceptionId: null,
      isReferenceLoading: false,

      searchCondition: null,

      patientCondition: null,
      departmentsCondition: [],
      unmanagedDocumentSummaryInformations: [],
    };
  }
  displaySetting: ReceptionListDispInfo;
  overLimitMessage: string;
  receptionList: ReceptionSummary[];
  selectedReception: ReceptionSummary;

  reference: ReceptionReference;
  isShowPreview: boolean;
  isLoading: boolean;
  isRegistering: boolean;
  isReferenceLoading: boolean;
  preReceptionId: number;
  searchCondition: ReceptionSearchCondition;

  patientCondition: Patient;
  departmentsCondition: Department[];
  unmanagedDocumentSummaryInformations: UnmanagedDocumentSummaryInformation[];

  
  async created() {
    if (this.isDepartmentGroupEnable) {
      this.selectedDepartmentGroup = this.storedDepartmentGroup;
    }
    await this.getDispSetting();
  }

  mounted(): void {
    // $refsはリアクティブではない模様.マウント後に初期化.
    this.departmentsCondition = this.defaultDepartmentsCondition;
  }

  @Emit()
  changeButtonInfo(buttons: DocumentCreateButtonInfo[]): void {}

  @Emit()
  changeNewReceptionButtonEnable(isEnable: boolean): void {}

  @Emit()
  changeDocumentListButtonEnable(isEnable: boolean): void {}

  @Emit()
  changePatientCondition(value: Patient): void {}

  @Emit()
  saveDepartmentsCondition(value: Department[]): void {}

  @Watch("patientCondition")
  onPatientChanged(newValue: Patient, oldValue: Patient) {
    this.changePatientCondition(newValue);
    
    // if (!newValue) { return; } // 終了・条件無しでもそんなに遅くないので、どういう条件でも再検索かける
    this.searchReception();
  }

  @Watch("departmentsCondition")
  onDepartmentChanged(newValue: Department[], oldValue: Department[]) {
    // if (!newValue || newValue.length === 0) { return; } // 終了・条件無しでもそんなに遅くないので、どういう条件でも再検索かける

    this.searchReception();
  }

  @Watch("selectedDepartmentGroup")
  onSelectedDepartmentGroupChanged() {
    this.searchReception();
  }

  get isDepartmentGroupConflicted(): boolean {
    return this.departmentsCondition
      && this.selectedDepartmentGroup
      && this.departmentsCondition.some(d => !this.selectedDepartmentGroup.departments.some(g => g.id === d.id));
  }

  get departmentSearchCondition(): Department[] {
    return this.departmentsCondition && this.departmentsCondition.length > 0
      ? this.departmentsCondition
      : this.selectedDepartmentGroup
        ? this.selectedDepartmentGroup.departments
        : [];
  }

  // ---------------------Emitで呼ばれる--------------------------------

  onSelectReception(value: ReceptionSummary) {
    this.$logger.debug("onSelectedReception");
    this.selectedReception = value;
    this.reference = null;
  }

  // 依頼削除通知を受け取りました
  onDeletedReceptionDetail() {
    this.$logger.debug("onDeletedReceptionDetail");

    // this.reference = null;

    // 受付一覧から再取得
    this.searchReception();
  }

  // WF実行通知を受け取りました
  onDoActionedReceptionDetail() {
    this.$logger.debug("onDoActionedReceptionDetail");

    // this.reference = null;

    // 受付一覧から再取得
    this.searchReception();
  }

  // 依頼書削除通知を受け取りました
  onRequestSheetDeleted() {
    this.$logger.debug("onRequestSheetDeleted");

    // できれば依頼だけを読み込み直したいが、大幅な修正が必要になる見込みのため、
    // 暫定で受付一覧から再取得する挙動としている
    this.searchReception();
  }

  hidePreview() {
    if (this.isIE()) {
      this.isShowPreview = false;
    }
  }

  showPreview() {
    if (this.isIE()) {
      this.isShowPreview = true;
    }
  }

  onStartedReferenceLoading() {
    this.$logger.debug("onStartedReferenceLoading");
    this.isReferenceLoading = true;
  }

  onStopedReferenceLoading() {
    this.$logger.debug("onStopedReferenceLoading");
    this.isReferenceLoading = false;
  }

  // 依頼受付検索依頼が届きました
  async onExecReceptionSearch(condition: ReceptionSearchCondition, needConfirm: boolean): Promise<void> {
    this.$logger.debug("onExecReceptionSearch");
    if (this.needConfirmBeforeSearch(needConfirm)) {
      const index = await this.$commonDialogs.confirmation.confirmExecuteCancel(
        null,
        ["検索に時間がかかる可能性がありますが、実行しますか？"]
      );
      if (index === 0) {
        this.execReceptionSearch(condition);
      }
      return;
    }

    this.execReceptionSearch(condition);
  }

  private needConfirmBeforeSearch(needConfirm: boolean): boolean {
    // 患者未指定の場合は確認要
    return needConfirm && !this.patientCondition;
  }

  private execReceptionSearch(condition: ReceptionSearchCondition): void {
    this.searchCondition = condition.clone();
    if (condition.isParamPatientSearch) { // 初回のみ
      this.getParamPatientInfo();
    } else {
      this.searchReception();
    }
  }

  // 子どもから汎用フラグ更新通知がきました
  onGeneralFlagUpdated(): void {
    console.log("onGeneralFlagUpdated");
    this.searchReception();
  }

  // --------------依頼受付用ボタン------------------------

  get receptionPermissions(): ReceptionPermissions {
    return this.selectedReception ? this.selectedReception.permissions : null;
  }

  // 編集ボタン
  get editPermission(): ButtonInfo {
    return this.receptionPermissions ? this.receptionPermissions.edit : null;
  }

  get editableReception(): boolean {
    return this.editPermission ? this.editPermission.isPermitted : false;
  }

  // 削除ボタン
  get deletePermission(): ButtonInfo {
    return this.receptionPermissions ? this.receptionPermissions.delete : null;
  }

  get deletableReception(): boolean {
    return this.deletePermission ? this.deletePermission.isPermitted : false;
  }

  // 引用ボタン
  get quotePermission(): ButtonInfo {
    return this.receptionPermissions ? this.receptionPermissions.quote : null;
  }

  get quotableReception(): boolean {
    return this.quotePermission ? this.quotePermission.isPermitted : false;
  }

  // コピーボタン
  get copyPermission(): ButtonInfo {
    return this.receptionPermissions ? this.receptionPermissions.copy : null;
  }

  get copyableReception(): boolean {
    return this.copyPermission ? this.copyPermission.isPermitted : false;
  }

  get searchConditionSummary(): string {
    return this.searchCondition ? this.searchCondition.getSummary(this.displaySetting.labelSetting.generalFlag1LabelName) : "";
  }

  get hasParamPatientNo(): boolean {
    return this.paramPatientNo ? true : false;
  }

  // --------------------コメントエリア--------------------------------

  get isRegistered(): boolean {
    return this.reference ? !this.reference.reception.isTemporary : false;
  }

  get isDeleted(): boolean {
    return this.reference ? this.reference.receptionDetail.deleted : false;
  }

  get detail(): ReceptionDetail {
    return this.reference ? this.reference.receptionDetail : null;
  }

  get detailId(): number {
    return this.detail ? this.detail.id : null;
  }

  get commentSet(): ReceptionCommentSet {
    return this.reference ? this.reference.receptionDetail.commentSet : new ReceptionCommentSet();
  }

  get labelSetting(): ReceptionDispInfo {
    return this.displaySetting ? this.displaySetting.labelSetting : null;
  }

  get generalFlag1LabelName(): string {
    return this.labelSetting ? this.labelSetting.generalFlag1LabelName : "";
  }

  get isGeneralFlag1Enable(): boolean {
    return this.labelSetting ? this.labelSetting.isGeneralFlag1Visible : true;
  }

  get generalFlag1(): boolean {
    return this.reference ? this.reference.reception.delivery.generalFlag1 : false;
  }

  get isInOutTypeEnable(): boolean {
    return this.labelSetting && this.labelSetting.isInOutTypeVisible;
  }

  get commentSetting(): ReceptionCommentDispInfo {
    return this.displaySetting ? this.displaySetting.commentSetting : null;
  }

  // --------------依頼詳細用ボタン------------------------

  get permissions(): ReceptionDetailPermissions {
    return this.reference ? this.reference.displayInfo.permissions : null;
  }

  get editDetailPermission(): ButtonInfo {
    return this.permissions ? this.permissions.edit : null;
  }

  get permittedEditDetail(): boolean {
    return this.editDetailPermission ? this.editDetailPermission.isPermitted : false;
  }

  // ---------------------表示用----------------------------------

  get isPaperNameEnable(): boolean {
    return this.labelSetting && this.labelSetting.isPaperNameVisible;
  }

  get isPaperCompanyNameEnable(): boolean {
    return this.labelSetting && this.labelSetting.isPaperCompanyNameVisible;
  }

  get defaultSelectedContentTab(): ReceptionReferenceKinds {
    return (this.displaySetting && this.displaySetting.defaultSelectedContentTab)
      ? this.displaySetting.defaultSelectedContentTab
      : ReceptionReferenceKinds.Document;
  }

  // --------------------メソッド---------------------------------

  // 受付編集
  editReception(): void {
    const param: any = {
      receptionId: this.selectedReception.id
    };
    this.$openWindow("/EditReception", param);
  }

  // 受付削除
  async deleteReception(): Promise<void> {
    const repository = DomainRegistry.workflow.getWorkflowRepository();
    const editTokens = await repository.getReceptionIdDocumentTokens(this.selectedReception.id);
    if (editTokens && 0 < editTokens.length) {
      const ret = await this.workflowActionConfirmDialog.show(editTokens, this.deletePermission.buttonName, this.deletePermission.confirmMessage);
      if (!ret) { return; }
    }

    const index = await this.$commonDialogs.confirmation.confirmDeleteCancel(
      "削除確認",
      ["依頼受付を削除してもよろしいですか？"]
    );
    if (index === 0) {
      this.execDeleteReception(this.selectedReception.id);
    }
  }

  // 受付引用
  async quoteReception(): Promise<void> {
    await this.getUnmanagedDocumentSummaryInformations(this.selectedReception.id);
    this.confirmActiveOnly()
    .then(isActiveOnly => {
      const param: any = {
        createKind: ReceptionCreateKinds.Quote,
        sourceReceptionId: this.selectedReception.id,
        isActiveOnly: isActiveOnly,
        isUnmanaged: Enumerable.from(this.unmanagedDocumentSummaryInformations).any(d => d.isUnmanaged),
      };
      this.$openWindow("/NewReception", param);
    })
    .catch(e => {
      this.$logger.info("ユーザ操作でキャンセルされました.");
    });
  }

  // 受付コピー
  copyReception(): void {
    this.confirmActiveOnly()
    .then(isActiveOnly => {
      const param: any = {
        createKind: ReceptionCreateKinds.Copy,
        sourceReceptionId: this.selectedReception.id,
        isActiveOnly: isActiveOnly,
      };
      this.$openWindow("/NewReception", param);
    })
    .catch(e => {
      this.$logger.info("ユーザ操作でキャンセルされました.");
    });
  }

  private async confirmActiveOnly(): Promise<boolean> {
    if (!this.selectedReception.hasDeletedDetail) {
      return false;
    }
    const index = await this.$commonDialogs.confirmation.show({
      message: [
        "削除済みの依頼文書が含まれています。",
        "作成する依頼に削除済みの依頼文書も含めますか？",
      ],
      buttons: [
        {
          kind: "confirm",
          label: "含める",
        },
        {
          kind: "danger",
          label: "含めない",
        }
      ],
      cancellation: {
        isEnable: true,
      },
    });
    if ((index === null) || (index === undefined)) {
      throw new Error("cancelled.");
    }
    return (index !== 0);
  }
  
  // --------------------API通信-----------------------------------

  async getDispSetting(): Promise<void> {
    try {
      const repository = DomainRegistry.workflow.getWorkflowRepository();
      this.isLoading = true;
      const result = await repository.getReceptionListInitSetting();
      this.isLoading = false;

      this.$logger.debug("displaySetting is set.");
      this.displaySetting = result;
      this.changeButtonInfo(this.displaySetting ? this.displaySetting.documentCreateButtons : []);
      this.changeNewReceptionButtonEnable(this.displaySetting ? this.displaySetting.isNewReceptionButtonEnable : true);
      this.changeDocumentListButtonEnable(this.displaySetting ? this.displaySetting.isDocumentListButtonEnable : true);
      this.changeManagerHistorySearchEnable(this.displaySetting ? this.displaySetting.isManagerHistorySearchEnable : false);
    } catch (e) {
      this.isLoading = false;
      this.$error("エラー", "表示設定の取得に失敗しました。", e);
    }
  }

  // パラメータで指定された患者情報を取得
  async getParamPatientInfo(): Promise<void> {
    if (!this.paramPatientNo) { return; }
    try {
      const repository = DomainRegistry.patient.getPatientRepository();
      this.isLoading = true;
      const result = await repository.getEntity(this.paramPatientNo);
      this.isLoading = false;
  
      this.$logger.debug("param patient is set.");
      this.patientCondition = result;
    } catch (e) {
      this.isLoading = false;
      this.$error("エラー", "指定患者の取得に失敗しました。", e);
    }
  }

  // 依頼受付検索
  async searchReception(): Promise<void> {
    if (!this.searchCondition) {
      this.$logger.debug("searchConditionがまだ設定されていないので依頼受付検索を中断します。");
      return;
    }
    if (this.isDepartmentGroupConflicted) {
      this.$logger.debug(this.$wording.common.departmentGroup + "に存在しない" + this.$wording.common.department + "が選択されているため検索を中断します。");
      this.receptionList = [];
      return;
    }
    try {
      // 今選択状態の受付IDをバックアップ
      this.preReceptionId = this.selectedReception ? this.selectedReception.id : null;
      // 依頼詳細を未選択状態に
      this.reference = null;

      // 検索前にリストを空に（メモリ対策）
      this.receptionList = [];
      
      // 患者と診療科をセット
      this.searchCondition.patient = this.patientCondition;
      this.searchCondition.departments = this.departmentsCondition;
      this.searchCondition.isDepartmentGroupSpecified = !!this.selectedDepartmentGroup;
      const condition = this.searchCondition.clone();
      condition.departments = this.departmentSearchCondition;

      const repository = DomainRegistry.workflow.getWorkflowRepository();
      this.isLoading = true;
      const result = await repository.searchReception(condition);
      this.overLimitMessage = result.overLimitMessage;
      // ソートする
      this.sortReceptions(result.list);
      this.receptionList = result.list; // vue 側でWatch、選択状態を復元させる
      this.isLoading = false;

    } catch (e) {
      this.isLoading = false;
      this.$error("エラー", "依頼一覧の取得に失敗しました。", e);
    }
  }

  sortReceptions(list: ReceptionSummary[]): void {
    // view側で実装
  }

  private async execDeleteReception(receptionId: number): Promise<void> {
    const repository = DomainRegistry.workflow.getWorkflowRepository();
    try {
      this.isRegistering = true;
      const result = await repository.deleteReception(receptionId);
      this.isRegistering = false;
      this.showPreview();
      if (result.success) {
        this.$success("成功", "依頼受付の削除に成功しました。");
        // 再検索
        this.searchReception();
      } else {
        this.$error("エラー", result.message + "\n" + result.reason);
      }
    } catch (e) {
      this.showPreview();
      this.isRegistering = false;
      this.$error("エラー", "依頼受付の削除に失敗しました。", e);
    }
  }

  // 管理外文書の記載済み文書情報取得
  private async getUnmanagedDocumentSummaryInformations(receptionId: number): Promise<void> {
    try {
      const repository = DomainRegistry.workflow.getWorkflowRepository();
      this.isLoading = true;
      this.unmanagedDocumentSummaryInformations = await repository.getUnmanagedDocumentSummaryInformations(receptionId);
      this.isLoading = false;
    } catch (e) {
      this.isLoading = false;
      this.$error("エラー", "依頼一覧の取得に失敗しました。", e);
    }
  }
}
